export const VERSION = '1.6.0'
export const MapApiKey = 'AIzaSyDe_U6iup053C8KiL_k-Mjy5P4y-xESE1Y'

//const DEV_HOST = 'http://172.24.1.1'
const DEV_HOST = 'http://vpplab.aniot.io:8080'
//const DEV_HOST = 'http://sm.inups.kr'

export const HOST = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? DEV_HOST : ''

const BASE = HOST + '/rest/'
export const SERVERS   = BASE + 'servers/'
export const DRIVERS   = BASE + 'drivers/'
export const DEVICES   = BASE + 'devices/'
export const CHANNELS  = BASE + 'channels/'
export const USERS     = BASE + 'users/'
export const SYSTEMS   = BASE + 'system/'
export const JOLOKIA   = HOST + '/jolokia/'

export const SIGNON  = HOST+'/login'
export const SIGNOFF = HOST+'/logout'

export const authlevel = ['System', 'Admin', 'User', 'Guest']
export const UNITS = ['', 'K', 'M', 'G', 'T']
export const EVENT = {
  SITE: 11,
}
export const siteStateOptions = [
  { value: '0', label: 'Operation' },
  { value: '1', label: 'Subscribed' },
  { value: '2', label: 'Maintenance' },
  { value: '8', label: 'Experiment' },
  { value: '9', label: 'Unsubscribed' },
]
export const GEN_TYPE = [
  { value: 'P', label: 'Photovoltaic Power' },
  { value: 'W', label: 'Wind Power' },
  { value: 'E', label: 'Electric Storage' },
]

export const CAPACITY = [
  { value: 'S', label: '< 100 kWh' },
  { value: 'M', label: '< 1,000 kWh' },
  { value: 'L', label: '> 1,000 kWh' },
]
export const LOCATIONS = [
  { value: '02' , label: '서울' },
  { value: '31' , label: '경기' },
  { value: '32' , label: '인천' },
  { value: '33' , label: '강원' },
  { value: '41' , label: '충남' },
  { value: '42' , label: '대전' },
  { value: '43' , label: '충북' },
  { value: '44' , label: '세종' },
  { value: '51' , label: '부산' },
  { value: '52' , label: '울산' },
  { value: '53' , label: '대구' },
  { value: '54' , label: '경북' },
  { value: '55' , label: '경남' },
  { value: '61' , label: '전남' },
  { value: '62' , label: '광주' },
  { value: '63' , label: '전북' },
  { value: '64' , label: '제주' },
]



// WEBPACK FOOTER //
// ./src/lib/constants.js